import styled from 'styled-components';
import { Flexer } from '@ontruck/orc';

export const StyledFlexParent = styled(Flexer.Parent)`
  width: 100%;
  flex: 1;
`;

export const StyledFlexChild = styled(Flexer.Child)`
  width: 33%;
`;
